// Configuration file for environment-specific settings
// 
// DEPLOYMENT SCENARIOS:
// 1. LOCAL DEVELOPMENT: Uses localhost:8099 (backend runs on port 8099)
// 2. REMOTE/PRODUCTION: Uses https://tasacionesya.com:8099 (backend runs on port 8099)
// 3. CUSTOM: Set environment variables to override
//
// USAGE:
// - npm run start:local     -> Forces localhost:8099
// - npm run start:remote    -> Forces https://tasacionesya.com:8099  
// - npm run start:prod      -> Forces https://tasacionesya.com:8099
// - npm start               -> Defaults to remote (https://tasacionesya.com:8099)
// - For local backend: Set REACT_APP_USE_LOCAL_BACKEND=true in .env
//
const config = {
  // Development environment (local backend)
  development: {
    apiBaseUrl: 'http://localhost:8099',
    domain: 'localhost',
    protocol: 'http'
  },
  
  // Remote testing environment (remote backend)
  remote: {
    apiBaseUrl: 'https://tasacionesya.com:8099',
    domain: 'tasacionesya.com',
    protocol: 'https'
  },
  
  // Production environment
  production: {
    apiBaseUrl: 'https://tasacionesya.com:8099',
    domain: 'tasacionesya.com',
    protocol: 'https'
  }
};

// Determine current environment
// You can force specific environment by:
// 1. Setting FORCE_ENVIRONMENT below
// 2. Creating a .env file with: REACT_APP_FORCE_ENVIRONMENT=development/remote/production
const FORCE_ENVIRONMENT = null; // Set to null to auto-detect, or 'development', 'remote', 'production' to force

let currentEnv;
if (FORCE_ENVIRONMENT) {
  currentEnv = FORCE_ENVIRONMENT;
} else if (process.env.REACT_APP_FORCE_ENVIRONMENT) {
  currentEnv = process.env.REACT_APP_FORCE_ENVIRONMENT;
} else if (process.env.REACT_APP_ENVIRONMENT) {
  currentEnv = process.env.REACT_APP_ENVIRONMENT;
} else if (process.env.NODE_ENV === 'development' && 
           (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
           process.env.REACT_APP_USE_LOCAL_BACKEND === 'true') {
  // Only use localhost backend if explicitly configured
  currentEnv = 'development';
} else {
  // Default to remote/production for all other cases
  currentEnv = 'production';
}

// Export the appropriate configuration
export const currentConfig = config[currentEnv];

// Convenience exports
export const apiBaseUrl = currentConfig.apiBaseUrl;
export const domain = currentConfig.domain;
export const protocol = currentConfig.protocol;

// For backward compatibility
export const url = currentConfig.apiBaseUrl;

// Environment configured: ${currentEnv} -> ${apiBaseUrl}

export default currentConfig; 